import { Influencer, MediaType } from '@core/models/ApiFields/ig-field-values.types';

export const MEDIA_TYPE = {
    reels: 'reels',
    feed: 'feed',
    story: 'story',
    tag: 'tag',
    mention: 'mention',
    ad: 'ad',
    others: 'others',
    posts: 'posts',
} as const;

export const MEDIA_TYPE_ARR: MediaType[] = Object.values(MEDIA_TYPE);

export const CONTENT_TYPE = {
    IMAGE: 'image',
    VIDEO: 'video',
    CAROUSEL_ALBUM: 'carousel_album',
} as const;

export const COMMENT_SENTIMENT = {
    POSITIVE: 'POSITIVE',
    NEGATIVE: 'NEGATIVE',
    NEUTRAL: 'NEUTRAL',
} as const;

export const INFLUENCER = {
    NO: 'no',
    NANO: 'nano',
    MICRO: 'micro',
    MID_TIER: 'mid_tier',
    MACRO: 'macro',
    CELEBRITY: 'celebrity',
} as const;
export const influencerValues = Object.values(INFLUENCER);
export const influencerOptions = [
    { value: INFLUENCER.NO, display: 'No' },
    { value: INFLUENCER.NANO, display: 'Nano' },
    { value: INFLUENCER.MICRO, display: 'Micro' },
    { value: INFLUENCER.MID_TIER, display: 'Mid-tier' },
    { value: INFLUENCER.MACRO, display: 'Macro' },
    { value: INFLUENCER.CELEBRITY, display: 'Celebrity' },
];
export const isInfluencer = (value: string): value is Influencer =>
    influencerValues.includes(value as Influencer);

export const GENDER = {
    MALE: 'male',
    FEMALE: 'female',
    UNKOWN: 'unknown',
} as const;

export const AGE_RANGE = {
    '-13': '13-',
    '13-17': '13-17',
    '18-24': '18-24',
    '25-34': '25-34',
    '35-44': '35-44',
    '45-54': '45-54',
    '55-64': '55-64',
    '65+': '65+',
} as const;

export const AUD_TYPES = {
    ENGAGED: 'engaged_audience_demographics',
    REACHED: 'reached_audience_demographics',
    FOLLOWER: 'follower_demographics',
} as const;
